import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { StateOfCarService } from '@app/shared/services/state-of-car.service';
declare var UIkit: any;

@Component({
  selector: 'app-states-of-car-management',
  templateUrl: './states-of-car-management.component.html',
  styleUrls: ['./states-of-car-management.component.scss']
})
export class StatesOfCarManagementComponent {

  public loading: boolean = true;
  public selectedState: any = {};
  public status: number = 0;
  @Input() statesOfCar: any = [];
  @Output() changed = new EventEmitter();

  constructor(
    private stateOfCarService: StateOfCarService
  ) {}

  ngOnChanges(changes): void {
    if (this.statesOfCar.length === 0) {
      this.loading = true;
    } else {
      this.selectedState = this.statesOfCar[0];
      this.status = this.statesOfCar[0].state;
      this.loading = false;
    }
  }

  updateStatus() {
    let promises: Array<any> = [];

    this.statesOfCar.forEach((state) => {
      promises.push(this.stateOfCarService.updateSinisterState(state.idStateOfCar, this.status));
    });
    Promise.all(promises).then(() => {
      this.changed.emit();
      UIkit.modal('#state-of-car-management').hide();
    });
  };

}
